<template>
  <v-container v-if="variant">
    <v-row>
      <v-col
        cols="12"
        md="6">
        <LocationAndShiftModel
          :node-id="nodeId"
          :variant="variant" />
        <AnnualParts
          :node-id="nodeId"
          :variant="variant" />
      </v-col>
      <v-col
        cols="12"
        md="6">
        <CarouselWithUpload
          v-if="realLocation"
          field="location_images"
          :node-id="realLocation"
          read-only />
        <v-container class="bordered bg-white">
          <NotesEditor
            :id="nodeId"
            field="calculation_variant_notes"
            :placeholder="t('entities.variant.fields.base_data_notes')" />
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useTranslation } from "i18next-vue";

import CarouselWithUpload from "@/components/Elements/CarouselWithUpload.vue";
import LocationAndShiftModel from "./CalculationVariantParts/LocationAndShiftModel.vue";
import AnnualParts from "./CalculationVariantParts/AnnualParts.vue";

import { useSpaceStore } from "../../../../stores/spaceStore";
import NormalInput from "@/components/Elements/NormalInput.vue";
import NotesEditor from "@/components/Elements/NotesEditor.vue";
import { computed } from "vue";
import { useTreeStore } from "@/stores/treeStore";

const { t } = useTranslation();
const spaceStore = useSpaceStore();
const treeStore = useTreeStore();

const variant = ref(null);
const calculation_variant_notes = ref(null);

const props = defineProps({
  nodeId: {
    type: String,
    required: true
  }
});

onMounted(() => {
  variant.value = spaceStore.getElement(props.nodeId);
});

const realLocation = computed(() => {
  return treeStore.elementLocation[props.nodeId];
});
</script>
